import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * Defines a store of protocol ids accumulated for the app session,
 * so a selection made on another page or before navigating away still counts.
 */
export const defineProtocolIdSetStore = (storeId: string) =>
    defineStore(storeId, () => {
        const ids = ref(new Set<string>());

        const add = (id: string) => {
            ids.value.add(id);
        };

        const has = (id: string) => ids.value.has(id);

        return { ids, add, has };
    });
